const emailKey = {
    USER_ID: `user_83dD9cvtRfz23akWcefNK`, //user
    TEMPLATE_ID: `template_yf6rd1e`,        //templateID
    SERVICE_ID : 'service_jc00u2f' //serviceID
}

export default emailKey